import { ErrorMessage, Field } from "formik";
import { CardBody, CardHeader, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import { H6 } from "../../../AbstractElements";
import { useState } from "react";

interface AppsApiSettingsSectionProps {
  isEdit?: boolean;
}

const AppsApiSettingsSection = ({ isEdit }: AppsApiSettingsSectionProps) => {
  const { t } = useTranslation();
  const [showApiSettings, setShowApiSettings] = useState(false);

  return (
    <div className="mb-4">
      <CardHeader>
        <div className='d-flex justify-content-between'>
          <h5>{t("AppsandAPISettings")}</h5>
          <div className={`flex-shrink-0 text-end icon-state`}>
            <Label className="switch">
              <Input 
                type="checkbox"   
                checked={showApiSettings}
                onChange={() => setShowApiSettings((prev) => !prev)}
              />
              <span className="switch-state"></span>
            </Label>
          </div>
        </div>
      </CardHeader>
      {!showApiSettings ? (
        <CardBody>
          <Row>
            <Col sm="4">
              <FormGroup>
                <label>{t("OrganizationBrowserGoogleKey")}</label>
                <Field
                  name="GoogleKey"
                  type="text"
                  className="form-control"
                  placeholder={t("OrganizationBrowserGoogleKeyPlaceholder")}
                />
                <ErrorMessage
                  name="GoogleKey"
                  component="span"
                  className="text-danger"
                />
              </FormGroup>
            </Col>
            <Col sm="4">
              <FormGroup>
                <label>{t("EmployeeAppAndroidKey")}</label>
                <Field
                  name="androidKey"
                  type="text"
                  className="form-control"
                  placeholder={t("EmployeeAppAndroidkeyplaceholder")}
                />
                <ErrorMessage
                  name="androidKey"
                  component="span"
                  className="text-danger"
                />
              </FormGroup>
            </Col>
            <Col sm="4">
              <FormGroup>
                <label>{t("EmployeeAppAndroidURL")}</label>
                <Field
                  name="androidURL"
                  type="text"
                  className="form-control"
                  placeholder={t("EmployeeAppAndroidURLplaceholder")}
                />
                <ErrorMessage
                  name="androidURL"
                  component="span"
                  className="text-danger"
                />
              </FormGroup>
            </Col>
            <Col sm="4">
              <FormGroup>
                <label>{t("EmployeeAppIOSKey")}</label>
                <Field
                  name="iosKey"
                  type="text"
                  className="form-control"
                  placeholder={t("EmployeeAppIOSkeyplaceholder")}
                />
                <ErrorMessage
                  name="iosKey"
                  component="span"
                  className="text-danger"
                />
              </FormGroup>
            </Col>
            <Col sm="4">
              <FormGroup>
                <label>{t("EmployeeAppIOSURL")}</label>
                <Field
                  name="iosURL"
                  type="text"
                  className="form-control"
                  placeholder={t("EmployeeAppIOURLplaceholder")}
                />
                <ErrorMessage
                  name="iosURL"
                  component="span"
                  className="text-danger"
                />
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      ) : (
        <div>
          <Col sm="12" className="empty-cart-cls text-center">
            <H6>{"Applied settings are from your most default configuration"}</H6>
          </Col>
        </div>
      )}
    </div>
  );
};

export default AppsApiSettingsSection; 